import { useRouter } from '@tanstack/react-router';
import { toast } from 'sonner';

import { useCopyToClipboard } from '@/shared/hooks/useCopyToClipboard';

/**
 * Copies a clean link to a workflow's own page, where a reader can copy it home
 * (spec 205), never to the sender's filters. One hook, so every Copy link
 * copies the same address and says the same thing.
 */
export function useCopyWorkflowLink(workspaceId: string, workflowKey: string) {
  const router = useRouter();
  const { copy } = useCopyToClipboard();

  return async () => {
    const { href } = router.buildLocation({
      to: '/workspaces/$workspaceId/workflows/$workflowKey',
      params: { workspaceId, workflowKey },
    });
    if (await copy(`${window.location.origin}${href}`)) {
      toast('Link copied');
    } else {
      toast.error(
        'The link could not be copied — your browser refused the clipboard.',
      );
    }
  };
}
